<div class="layout__main-modal">
  <div
    mat-dialog-title
    class="dialog-title"
  >
    <div class="title">Forward to...</div>
  </div>
  <mat-dialog-content class="dialog-content">
    <div class="message">Please enter the recipient’s info</div>
    <div>
      <mat-form-field
        *ngIf="mode === 'selection'"
        class="full-width"
      >
        <mat-select
          [formControl]="selectFormControl"
          [compareWith]="compareRecipient"
          placeholder="Assign"
        >
          <mat-select-trigger>
            <span *ngIf="selectFormControl.value">
              {{ selectFormControl.value?.name + ' • ' + selectFormControl.value?.email }}
            </span>
            <span *ngIf="!selectFormControl.value">Add recipient</span>
          </mat-select-trigger>
          <mat-option
            class="redr-field-dropdown-item second-line"
            *ngFor="let recipient of recipients"
            [matTooltip]="recipient.email"
            matTooltipPosition="above"
            [value]="recipient"
          >
            <div class="redr-signature-field-toolbar assigner-group-item">
              <div class="assigner-group__info">
                <div
                  class="assigner-group__primary"
                  direction="row"
                >
                  <span class="assigner-group__bold assigner-group__truncate">{{ recipient.name }}</span>
                </div>
                <div class="assigner-group__secondary">
                  <span class="assigner-group__truncate">{{ recipient.email }}</span>
                </div>
              </div>
            </div>
            <!-- {{recipient.name}} -->
          </mat-option>
          <mat-option
            [value]="'createNew'"
            class="redr-field-dropdown-item"
          >
            Add New ...
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <form
      *ngIf="mode === 'form'"
      [formGroup]="form"
    >
      <mat-form-field
        floatLabel="auto"
        class="full-width"
      >
        <mat-label>Name</mat-label>
        <input
          #inputLabel
          type="text"
          matInput
          formControlName="name"
          required
        />
        <mat-error *ngIf="form.controls['name'].hasError('required')"> This field is required</mat-error>
        <mat-error *ngIf="form.controls['name'].hasError('maxlength')">
          Maximum {{form.controls['name'].errors?.['maxlength'].requiredLength}} characters
        </mat-error>
      </mat-form-field>
      <mat-form-field
        floatLabel="auto"
        class="full-width"
      >
        <mat-label>Email</mat-label>
        <input
          type="text"
          matInput
          formControlName="email"
          required
          trim
          placeholder="Enter email"
        />
        <mat-error *ngIf="form.get('email')?.hasError('required')"> This field is required</mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')"> This email is not valid</mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="enablePhone"
        class="full-width"
      >
        <app-phone-number
          formControlName="phone"
          required
        >
        </app-phone-number>
        <mat-error *ngIf="form.controls['phone'].errors && form.controls['phone'].errors['required']"> This field is required </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      mat-button
      type="button"
      class="margin-right-40"
      (click)="close()"
    >
      Cancel
    </button>
    <button
      type="button"
      mat-button
      class="cimb-button--primary"
      (click)="submit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
</div>
